import { Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import type { TUser } from "@/types"
import { anniversaryDiff, dayjs } from "@/utils"
import { Panel } from "./utils"

const delta = 7

export function ProfileAnniversary({ user }: { user: TUser }) {
  const { t } = useTranslation()

  const days = anniversaryDiff(user.dtstart, 1)
  // check days is undefined or greater than delta
  if (days === undefined || days > delta) return null

  return (
    <Panel>
      <Stack p="md" align="center" justify="center" gap="sm" data-testid="anniversary">
        <Text fz={24} c="dimmed">
          {t("Work anniversary")}
        </Text>
        <Text fz={100} lh="100px">
          {days == 0 ? "🎖️" : days < 3 ? "🎊" : days < 5 ? "🤵" : "👔"}
        </Text>
        <Text fz={24} c="red" fw={500}>
          {days == 0
            ? t("Happy Anniversary!")
            : days == 1
              ? t("Tomorrow")
              : dayjs().startOf("day").add(days, "day").fromNow()}
        </Text>
      </Stack>
    </Panel>
  )
}
